import LoginWithSweetAlertContainer from "../../../../Components/OtherPages/Authentication/LoginWithSweetAlert/LoginWithSweetAlert"

const LoginWithSweetAlert = () => {
  return (
    <div className='page-body'>
      <LoginWithSweetAlertContainer />
    </div>
  )
}

export default LoginWithSweetAlert